import { Injectable } from '@angular/core';
import { ProductOrderHistoryList } from '@buyiq-app/product/models/order-history';
import { LocalForageService } from '@buyiq-core/storage/local-forage.service';
import {  OfflineStorage, StoreName } from '@buyiq-core/storage/storage';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OrderHistoryStorageService implements OfflineStorage<ProductOrderHistoryList> {
    constructor(
        private localForageService: LocalForageService
    ) {
    }

    clearStorage(): Observable<void> {
        return this.localForageService.clearStorage(StoreName.OrderHistory);
    }

    getItem(key: string): Observable<ProductOrderHistoryList> {
        return this.localForageService.getItem(key, StoreName.OrderHistory);
    }

    removeItem(key: string): Observable<void> {
        return this.localForageService.removeItem(key, StoreName.OrderHistory);
    }

    setItem(key: string, value: any): Observable<ProductOrderHistoryList> {
        return this.localForageService.setItem(key, value, StoreName.OrderHistory);
    }

    getAll(): Observable<Array<ProductOrderHistoryList>> {
        return this.localForageService.getAll(StoreName.OrderHistory);
    }
}
